import { client } from "../../../../src/App";
import { handlerErrors } from "../../../helpers/helpers";
import {
  CHANGE_BILL_EMAIL,
  DISABLE_BILL,
  ENABLE_BILL,
  getEvictionForMutation,
} from "../../../helpers/mutations";
import { hideLoading, showLoading } from "../../../reducers/app";

export const enableBills = async (
  contractId,
  email,
  dispatch,
  setGenericError,
  setInfoModal,
  setEnable,
  setRefresh,
  refresh,
  enableOnlineBillsDataLayer,
  enableOnlineBillsDataLayerKo
) => {
  const bill_data = {
    contractId: contractId,
    email: email,
  };
  try {
    dispatch(showLoading());
    setInfoModal({ active: false, type: null });
    const { data } = await client().mutate({
      mutation: ENABLE_BILL,
      variables: { req: bill_data },
      update: (cache) => {
        const fieldsToEvict = getEvictionForMutation("enableDigitalBill");
        fieldsToEvict.forEach((field) => cache.evict({ fieldName: field }));
        cache.gc();
      },
    });
    if (data && data.enableDigitalBill && data.enableDigitalBill.outcome) {
      window.dataLayer.push({ event: "attivazioneBollettaCompletata" });
      dispatch(hideLoading());
      if (setEnable) {
        setEnable(true);
      }
      setRefresh(!refresh);
    }
    if (enableOnlineBillsDataLayer) {
      enableOnlineBillsDataLayer();
    }
  } catch (e) {
    console.log(e);
    handlerErrors(e, setGenericError, setGenericError);
    setInfoModal({ active: true, type: "ERROR" });
    dispatch(hideLoading());
    if (enableOnlineBillsDataLayerKo) {
      enableOnlineBillsDataLayerKo();
    }
  }
};

export const disableBills = async (
  contractId,
  dispatch,
  setGenericError,
  setInfoModal,
  setEnable,
  setRefresh,
  refresh,
  disableOnlineBillsDataLayer,
  disableOnlineBillsDataLayerKo
) => {
  const bill_data = {
    contractId: contractId,
  };

  try {
    dispatch(showLoading());
    setInfoModal({ active: false, type: null });
    const { data } = await client().mutate({
      mutation: DISABLE_BILL,
      variables: { req: bill_data },
      update: (cache) => {
        const fieldsToEvict = getEvictionForMutation("disableDigitalBill");
        fieldsToEvict.forEach((field) => cache.evict({ fieldName: field }));
        cache.gc();
      },
    });
    if (data && data.disableDigitalBill && data.disableDigitalBill.outcome) {
      dispatch(hideLoading());
      if (setEnable) {
        setEnable(false);
      }
      setRefresh(!refresh);
    }
    if (disableOnlineBillsDataLayer) {
      disableOnlineBillsDataLayer();
    }
  } catch (e) {
    console.log(e);
    handlerErrors(e, setGenericError, setGenericError);
    setInfoModal({ active: true, type: "ERROR" });
    dispatch(hideLoading());
    if (disableOnlineBillsDataLayerKo) {
      disableOnlineBillsDataLayerKo();
    }
  }
};

export const changeEmailBills = async (
  contractId,
  email,
  dispatch,
  setGenericError,
  setInfoModal,
  setRefresh,
  refresh
) => {
  const bill_data = {
    contractId: contractId,
    email: email,
  };
  try {
    dispatch(showLoading());
    setInfoModal({ active: false, type: null });
    const { data } = await client().mutate({
      mutation: CHANGE_BILL_EMAIL,
      variables: { req: bill_data },
      update: (cache) => {
        const fieldsToEvict = getEvictionForMutation("changeDigitalBillEmail");
        fieldsToEvict.forEach((field) => cache.evict({ fieldName: field }));
        cache.gc();
      },
    });
    if (
      data &&
      data.changeDigitalBillEmail &&
      data.changeDigitalBillEmail.outcome
    ) {
      dispatch(hideLoading());
      setRefresh(!refresh);
    }
  } catch (e) {
    console.log(e);
    handlerErrors(e, setGenericError, setGenericError);
    setInfoModal({ active: true, type: "ERROR" });
    dispatch(hideLoading());
  }
};
